import React from 'react'
import PropTypes from 'prop-types'
import Accordion from '../../../components/Accordion/Accordion'

const Row = ({ children }) => {
    return (
        <div className="w-full h-auto flex flex-row items-center justify-between">
            {children}
        </div>
    )
}

Row.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.element,
        PropTypes.object,
    ]),
}

const EquipmentSpecs = ({ equipment, open, setOpen }) => {
    const renderContent = () => {
        return (
            <div className="w-full h-auto flex flex-col mt-4 gap-y-1">
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Capacity:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.capacity || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Lift Height:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.maxHeight || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Lower Height:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.loweredHeight || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Battery Charger:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.fuelType || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Tire Group:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.tireGroup || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Stages:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.numberOfStages || '-'}
                    </p>
                </Row>
                <Row>
                    <p className="text-textDarkGray font-semibold text-sm">
                        Directional Control:
                    </p>
                    <p className="text-textDarkerGray font-normal text-sm">
                        {equipment?.directionControl || '-'}
                    </p>
                </Row>
            </div>
        )
    }

    const onIsOpen = () => {
        setOpen('specs')
    }

    return (
        <Accordion
            text="Specs"
            hasBorder={true}
            content={renderContent()}
            isEquipmentInfo
            forceClose={open}
            onIsOpen={onIsOpen}
        />
    )
}

EquipmentSpecs.propTypes = {
    equipment: PropTypes.object,
    open: PropTypes.bool,
    setOpen: PropTypes.func,
}

export default EquipmentSpecs
